(function () {
  'use strict';

  /* ---------- Fade-up observer (shared with homepage) ---------- */
  if (typeof IntersectionObserver !== 'undefined') {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.c-fade-up').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ---------- Paradise card hover: secondary image swap ---------- */
  function initCardHover() {
    document.querySelectorAll('.paradise-card').forEach(function (card) {
      var alt = card.querySelector('.paradise-card__img-alt');
      var pri = card.querySelector('.paradise-card__img:not(.paradise-card__img-alt)');
      if (!alt || !pri) return;

      card.addEventListener('mouseenter', function () {
        alt.style.opacity = '1';
      });
      card.addEventListener('mouseleave', function () {
        alt.style.opacity = '0';
      });
    });
  }

  /* ---------- Ticker duplicate for seamless scroll ---------- */
  function initTicker() {
    var track = document.querySelector('.paradise-ticker__track');
    if (!track) return;
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  }

  /* ---------- Hero scroll CTA ---------- */
  function initHeroScroll() {
    var scrollHint = document.querySelector('.paradise-hero__scroll');
    if (!scrollHint) return;
    scrollHint.style.cursor = 'pointer';
    scrollHint.addEventListener('click', function () {
      var next = document.querySelector('.paradise-hero + *');
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ---------- Subtle parallax on hero pattern ---------- */
  function initParallax() {
    var hero = document.getElementById('paradise-hero');
    if (!hero) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y < window.innerHeight) {
            var pattern = hero.querySelector('.paradise-hero__pattern');
            if (pattern) {
              pattern.style.transform = 'translateY(' + (y * 0.15) + 'px)';
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  function init() {
    initCardHover();
    initTicker();
    initHeroScroll();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
